import { Component, OnInit, TemplateRef, AfterViewChecked, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Constants, loanType } from '../../Utilities/Constants/constants';
import { CommonService } from '../../service/common.service';
import { EditableGridService } from '../../Utilities/editableGrid/editable-grid.service';
import { DataService } from '../../service/data.service';
import { PropUnderwritingService } from '../../service/prop-underwriting.service';
import { Lead } from '../../model/lead';
import { PropertyUnderwriting } from '../../model/propertyUnderwriting';
import { SupplementalInformation } from '../../model/supplementalInformation';
import { NgModel, FormGroup } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { RouterExtService } from '../../service/router-ext.service';
import { ModelPopupComponent } from '../../shared/model-popup/model-popup.component';
declare var $: any;

@Component({
  selector: 'app-underwriting',
  templateUrl: './underwriting.component.html',
  styleUrls: ['./underwriting.component.css']
})
export class UnderwritingComponent implements OnInit {
  underWritingForm: FormGroup;
  LiveChatImage = '';
  formErrors: any = {};
  emptyDogsRowFlag: boolean = true;
  emptyOtherPetsRowFlag: boolean = true;
  emptyRennovationFlag: boolean = true;
  emptyClaimsFlag: boolean = true;
  errorInClaims: boolean = false;
  maxDate = new Date();
  hdnDog:any;
  hdnOtherPets:any;
  hdnRenovations:any;
  hdnLoss:any;
 @ViewChild(ModelPopupComponent)popUp:ModelPopupComponent;
 @ViewChild('ErrorDivDog') elemErrorDivDog: ElementRef;
 @ViewChild('ErrorOtherPets') elemErrorOtherPets: ElementRef;
 @ViewChild('ErrorRenovations') elemErrorRenovations: ElementRef;
 @ViewChild('ErrorLoss') elemErrorLoss: ElementRef;
  template: any;
  constructor(public router: Router,
    public commonService: CommonService,
    public editableGrid: EditableGridService,
    public dataService: DataService,
    public propService: PropUnderwritingService,
    public leadDetails: Lead,
    private modalService: BsModalService,
    private routerExtService: RouterExtService,
    public constantsObj: Constants) {
    this.LiveChatImage = constantsObj.LiveChatImage; 
  }
  modalRef: BsModalRef;
  PropertyUnderwriting: PropertyUnderwriting;
  _propObj = new PropertyUnderwriting();
  supplementalInfo: SupplementalInformation;
  isLoading = false;
  isRenters: boolean = false;
  swimmingPoolNoneID: string;
  isIEOrEdge: boolean;
  message: string = '';
  height: number=1300; 

  ngOnInit() {
    this.commonService.ScrollToRTQForm();
    this.commonService.SaveLeadHistory(); 
    this.dataService.leadHistory.pageNumber=4; 
    this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    this.leadDetails = this.dataService.leadDetails;
    //this.impersonateLead();
    this.PropertyUnderwriting = this.leadDetails.propertyUnderwriting;
    this.supplementalInfo = this.PropertyUnderwriting.supplementalInformation;
    this.isLoading = true;
    this.swimmingPoolNoneID = this.constantsObj.SwimmingPoolNone;
    //#Checking whether its previous button or not
    //this.leadDetails.leadID='F3102C5A-E735-4490-80A3-75AF46C755F6';
    if (this.CheckObject(this.supplementalInfo)) {
      this.propService.getPropUnderwritingInfo(this.leadDetails).subscribe((data: Lead) => {
        this.leadDetails = data;
        this.dataService.leadHistory.preValue=JSON.parse(JSON.stringify(data)); 
        this.PropertyUnderwriting = this.leadDetails.propertyUnderwriting;
        this.supplementalInfo = this.leadDetails.propertyUnderwriting.supplementalInformation;
        this.formatCurrency(this.supplementalInfo.lossHistories);
        this.isLoading = false;
        this.setEmptyRowFlag();
        this.initGrids();
      }, err => {
        this.dataService.handleError(err);
        this.isLoading = false;
      });
    }
    else {
      //#set the visibility of Loan Information
      if (this.leadDetails.loanType == loanType.Refinance)
        this.isRenters = true;
        this.setEmptyRowFlag();
        this.initGrids();
        this.formatCurrency(this.supplementalInfo.lossHistories);
        this.isLoading = false;
		    this.dataService.leadHistory.preValue=JSON.parse(JSON.stringify(this.dataService.leadDetails));
    }
   
  }
  setEmptyRowFlag() {

    if (this.supplementalInfo.haveDogs && this.supplementalInfo.dogs.length > 0) {
      if(this.supplementalInfo.dogs.some(obj => obj.breedID != '' || obj.explanation != '' || obj.haveBiteHistory != null || obj.mixedWithBreedID != '')){

        this.emptyDogsRowFlag = false;
      }else{
        this.emptyDogsRowFlag = true;
      } 
    }
    else{
      this.emptyDogsRowFlag = true;
    }

    if (this.supplementalInfo.haveOtherPets &&this.supplementalInfo.otherPets.length > 0) {
      if(this.supplementalInfo.otherPets.some(obj => obj.description != '')){
        this.emptyOtherPetsRowFlag = false;
      }else{
        this.emptyOtherPetsRowFlag = true;
      }
      
    }
    else{
      this.emptyOtherPetsRowFlag = true;
    }

    if (this.supplementalInfo.haveRenovation &&this.supplementalInfo.renovations.length > 0) {
      if(this.supplementalInfo.renovations.some(item => item.details != '' || item.extentType != '' || item.id != '' || item.type != '' || item.yearCompleted != '')){
        this.emptyRennovationFlag = false;
      }else{
        this.emptyRennovationFlag = true;
      }
      
    }
    else{
      this.emptyRennovationFlag = true;
    }

    if (this.supplementalInfo.haveClaims &&this.supplementalInfo.lossHistories.length > 0) {
      if(this.supplementalInfo.lossHistories.some(item => item.amountPaid != '' || item.cause != '' || item.date != null || item.id != '' || item.note != '')){
        this.emptyClaimsFlag = false;
      }else{
        this.emptyClaimsFlag = true;
      } 
    }
    else{
      this.emptyClaimsFlag = true;
    } 
    
  }

  impersonateLead() {
    if (this.leadDetails == null)
      this.leadDetails = new Lead();
    this.leadDetails.leadID = '98704FF1-A856-46F6-ADA4-6AA34D07669B';
    this.leadDetails.loanType = loanType.Owner;//Refinanace or H04
  }

  openModal(template: TemplateRef<any>, gridName: string) {
    if (gridName == 'dogs') {
      if (this.supplementalInfo.dogs != null && this.supplementalInfo.dogs.length > 0)
        if (!(this.supplementalInfo.dogs.length == 1 && this.supplementalInfo.dogs[0].breedID == ''
          && this.supplementalInfo.dogs[0].explanation == ''
          && this.supplementalInfo.dogs[0].haveBiteHistory == false
          && this.supplementalInfo.dogs[0].mixedWithBreedID == '')) {
          if (this.supplementalInfo.dogs.some(obj => obj.breedID != '' || obj.explanation != '' || obj.haveBiteHistory != null || obj.mixedWithBreedID != '')) {
            this.modalService.config.show = true;
            this.modalService.config.backdrop = "static";
            this.modalService.config.keyboard = false;
        this.modalRef = this.modalService.show(template, { class: 'dogs' });
      }
      }
       
    }
    if (gridName == 'otherPets') {
      if (this.supplementalInfo.otherPets != null && this.supplementalInfo.otherPets.length > 0)
      { 
        if (this.supplementalInfo.otherPets.some(obj => obj.description != '')) {
        this.modalService.config.show=true;
        this.modalService.config.backdrop="static";
        this.modalService.config.keyboard=false;
        this.modalRef = this.modalService.show(template, { class: 'otherPets' });
      }
      }
       
    }
    if (gridName == 'renovations') {
      if (this.supplementalInfo.renovations != null && this.supplementalInfo.renovations.length > 0)
      { 
        if (this.supplementalInfo.renovations.some(item => item.details != '' || item.extentType != '' || item.id != '' || item.type != '' || item.yearCompleted != '')) {
          this.modalService.config.show=true;
          this.modalService.config.backdrop="static";
          this.modalService.config.keyboard=false;
          this.modalRef = this.modalService.show(template, { class: 'renovations' });
        }
      }
    }

    if (gridName == 'loss') {
      if (this.supplementalInfo.lossHistories != null && this.supplementalInfo.lossHistories.length > 0)
      { 
        if (this.supplementalInfo.lossHistories.some(item => item.amountPaid != '' || item.cause != '' || item.date != null || item.id != '' || item.note != '')) {
          this.modalService.config.show=true;
          this.modalService.config.backdrop="static";
          this.modalService.config.keyboard=false;
          this.modalRef = this.modalService.show(template, { class: 'loss' });
        }
      }
    }
  }

  confirm(): void {
    if (this.modalService.config.class == 'dogs') {
      this.supplementalInfo.dogs = [{ breedID: '', explanation: '', haveBiteHistory: null, mixedWithBreedID: '',id:'' }];
      this.supplementalInfo.haveDogs = false;
      this.checkForEmptyRowForDogs();
    }
    if (this.modalService.config.class == 'otherPets') {
      this.supplementalInfo.otherPets = [{ description: '',leadID:'',id:''  }];
     this.supplementalInfo.haveOtherPets = false;
     this.checkForEmptyRowForOtherPets();
    }
    if (this.modalService.config.class == 'renovations') {
      this.supplementalInfo.renovations = [{ details: '', extentType: '', id: '', type: '', yearCompleted: '',leadID:'' }];
      this.supplementalInfo.haveRenovation = false;
      this.checkForEmptyRowForRennovation();
    }
    if (this.modalService.config.class == 'loss') {
      this.supplementalInfo.lossHistories = [{ amountPaid: '', cause: '', date: null, id: '', note: '',leadID:'' }];
      this.supplementalInfo.haveClaims = false;
      this.checkForEmptyRowForClaims();
    }

    this.modalRef.hide();
  }
  //Pop up decline method
  decline(): void {
    if (this.modalService.config.class == 'dogs') {
      this.supplementalInfo.haveDogs = true;
      this.checkForEmptyRowForDogs();
    }
    if (this.modalService.config.class == 'otherPets') {
      this.supplementalInfo.haveOtherPets = true;
      this.checkForEmptyRowForOtherPets();
    }

    if (this.modalService.config.class == 'renovations') {
      this.supplementalInfo.haveRenovation = true;
      this.checkForEmptyRowForRennovation();
      
    }
    if (this.modalService.config.class == 'loss') {
      this.supplementalInfo.haveClaims = true;
      this.checkForEmptyRowForClaims();
    }

    this.modalRef.hide();
  }
  UnCheck(template:any,formVal: string)
  {
    
    switch (formVal) {
      case "dogs": {
        this.supplementalInfo.haveDogs = false;
        this.openModal(template, 'dogs');
      }
      case "otherPets": {
       this.supplementalInfo.haveOtherPets=false;
       this.openModal(template, 'otherPets');
        break;
      }
      case "renovations": {
       this.supplementalInfo.haveRenovation=false;
       this.openModal(template, 'renovations');
        break;
      }
      case "loss": {
        this.supplementalInfo.haveClaims=false;
        this.openModal(template, 'loss');
        break;
      }
      default: {
        //statements; 
        break;
      }

    }
  }
  remove(id: any, formVal: string) {

    switch (formVal) {
      case "dogs": {
        this.supplementalInfo.dogs.splice(id, 1);
        this.checkForEmptyRowForDogs();
        break;
      }
      case "otherPets": {
        this.supplementalInfo.otherPets.splice(id, 1);
        this.checkForEmptyRowForOtherPets();
        break;
      }
      case "renovations": {
        this.supplementalInfo.renovations.splice(id, 1);
        this.checkForEmptyRowForRennovation();
        break;
      }
      case "loss": {
        this.supplementalInfo.lossHistories.splice(id, 1);
        this.checkForEmptyRowForClaims();
        break;
      }
      default: {
        //statements; 
        break;
      }
    }
  }

  checkForEmptyRowForOtherPets() {
    this.emptyOtherPetsRowFlag = true;
    this.supplementalInfo.otherPets.forEach((item) => {
      if (!(item.description == '')) {
        this.emptyOtherPetsRowFlag = false;
        return;
      }
    });
  }

  checkForEmptyRowForDogs() {
    this.emptyDogsRowFlag = true;
    this.supplementalInfo.dogs.forEach((item) => {
      if (!(item.breedID == '' && item.haveBiteHistory == null && item.explanation == '' && item.mixedWithBreedID == '')) {
        this.emptyDogsRowFlag = false;
        return;
      }
    });
  }


  checkForEmptyRowForRennovation() {
    this.emptyRennovationFlag = true;
    this.supplementalInfo.renovations.forEach((item) => {
      if (!(item.details == '' && item.extentType == '' && item.id == '' && item.type == '' && item.yearCompleted == '')) {
        this.emptyRennovationFlag = false;
        return;
      }
    });
  }

  checkForEmptyRowForClaims() {
    this.emptyClaimsFlag = true;
    this.supplementalInfo.lossHistories.forEach((item) => {
      if (!(item.amountPaid == '' && item.cause == '' && item.date == null && item.id == '' && item.note == '')) {
        this.emptyClaimsFlag = false;
        return;
      }
    });
  }

  add(formName: string) {
    if(this.height>2000)
     return
    switch (formName) {
      case "dogs":
        this.supplementalInfo.dogs.push({ breedID: '', explanation: '', haveBiteHistory: null, mixedWithBreedID: '',id:''  });
        break;
      case "otherPets":
        this.supplementalInfo.otherPets.push({ description: '' ,leadID:'',id:'' });
        break;
      case 'renovations':
        this.supplementalInfo.renovations.push({ details: '', extentType: '', id: '', type: '', yearCompleted: '' ,leadID:''});
        break;
      case 'loss':
        this.supplementalInfo.lossHistories.push({ amountPaid: '', cause: '', date: null, id: '', note: '' ,leadID:''});
        break;
      default:
        break;
    }
  }

  initGrids() {
    if (this.supplementalInfo.dogs.length <= 0)
      this.supplementalInfo.dogs.push({ breedID: '', explanation: '', haveBiteHistory: null, mixedWithBreedID: '',id:''  })
    if (this.supplementalInfo.otherPets.length <= 0)
      this.supplementalInfo.otherPets.push({ description: '',leadID:'',id:''  });
    if (this.supplementalInfo.renovations.length <= 0)
      this.supplementalInfo.renovations.push({ details: '', extentType: '', id: '', type: '', yearCompleted: '',leadID:'' });
    if (this.supplementalInfo.lossHistories.length <= 0)
      this.supplementalInfo.lossHistories.push({ amountPaid: '', cause: '', date: null, id: '', note: '',leadID:'' });
     
  }

  
  isFormValid(underWritingForm)
  {
    let status=true;
    
    if((this.emptyDogsRowFlag && this.supplementalInfo.haveDogs)){
      $('html,body').animate({ scrollTop: $(this.elemErrorDivDog.nativeElement.parentElement).offset().top - 100

      }, 'slow', ()=> {
       this.elemErrorDivDog.nativeElement.focus();
     });
      
      
    }else if(this.emptyOtherPetsRowFlag && this.supplementalInfo.haveOtherPets){ 
      
      $('html,body').animate({ scrollTop: $(this.elemErrorOtherPets.nativeElement.parentElement).offset().top - 100

      }, 'slow', ()=> {
       this.elemErrorOtherPets.nativeElement.focus();
     });
    }else if((this.emptyRennovationFlag && this.supplementalInfo.haveRenovation)){
      $('html,body').animate({ scrollTop: $(this.elemErrorRenovations.nativeElement.parentElement).offset().top - 100

      }, 'slow', ()=> {
       this.elemErrorRenovations.nativeElement.focus();
     });
    }else if(this.emptyClaimsFlag && this.supplementalInfo.haveClaims){
      $('html,body').animate({ scrollTop: $(this.elemErrorLoss.nativeElement.parentElement).offset().top - 100

      }, 'slow', ()=> {
       this.elemErrorLoss.nativeElement.focus();
     });
    }

    if((this.emptyDogsRowFlag && this.supplementalInfo.haveDogs) ||
      (this.emptyOtherPetsRowFlag && this.supplementalInfo.haveOtherPets) ||
      (this.emptyRennovationFlag && this.supplementalInfo.haveRenovation) ||
      (this.emptyClaimsFlag && this.supplementalInfo.haveClaims) )
    status=false; 
    return status && underWritingForm.valid;
  }

  toggleLocked()
  {
     
    if(this.supplementalInfo.locked==null)
    this.supplementalInfo.locked=true;
    else
    this.supplementalInfo.locked=!this.supplementalInfo.locked;
  }

  formatSupplementalInfo()
  {
    if(this.supplementalInfo.haveDogs==null)
    this.supplementalInfo.haveDogs=false;
    if(this.supplementalInfo.haveOtherPets==null)
    this.supplementalInfo.haveOtherPets=false;
    if(this.supplementalInfo.haveRenovation==null)
    this.supplementalInfo.haveRenovation=false;
    if(this.supplementalInfo.haveClaims==null)
    this.supplementalInfo.haveClaims=false;
    //Pool
    if(this.supplementalInfo.isPoolFence==null)
    this.supplementalInfo.isPoolFence=false
    if(this.supplementalInfo.haveSlideDivingBoard==null)
    this.supplementalInfo.haveSlideDivingBoard=false
    
    //Other
    if(this.supplementalInfo.haveTrampoline==null)
    this.supplementalInfo.haveTrampoline=false
    if(this.supplementalInfo.isVacant==null)
    this.supplementalInfo.isVacant=false



  }

   
  onSubmit(underWritingForm) {
    
    this.dataService.leadHistory.noUpdate=underWritingForm['form'].pristine;
    this.formErrors = {};
    this.formErrors = this.commonService.updateControls(underWritingForm);
    this.isLoading = true; 
    //#Will start the API call from the quote message: ie saving the details
    if (this.isFormValid(underWritingForm) ) {
      this.commonService.ScrollToRTQForm();
      this.formatSupplementalInfo();

      this.commonService.NavigateToPage('/real-time-quote/quote-message');

    }
    else {
      if (!this.isFormValid(underWritingForm)) {
        //this.setFormStatus(this.leadDetails.propertyUnderwriting.);
        this.commonService.focusFirstInvalidElement();
        this.isLoading = false;
        return;
      }
    }
  }
  savePageDetails() {
    this.isLoading = true;
    this.leadDetails.contactMeButtonClicked=true;
    this.dataService.leadHistory.noUpdate=false;
    this.commonService.CreateLeadHistoryObj(4,this.leadDetails);
    this.propService.postPropUnderwritingInfo(this.leadDetails).subscribe((data: Lead) => {
      this.commonService.SaveLeadHistoryFromContactBtn();
      this.leadDetails.propertyUnderwriting = data.propertyUnderwriting;
      this.isLoading = false;
      this.commonService.NavigateToPage('/real-time-quote/contact');
    }, err => {
      this.isLoading = false;
      this.dataService.handleError(err);
    });
  }

  ngOnDestroy() {
    this.leadDetails.propertyUnderwriting.supplementalInformation = this.supplementalInfo;
    this.dataService.leadDetails = this.leadDetails;
    this.commonService.EmptyLeadObject();
  }


  CheckObject(supplementalInfo: SupplementalInformation) {
    if (supplementalInfo.lstPoolTypes.length == 0 ||
      (supplementalInfo.lstBreedTypes.length == 0) ||
      (supplementalInfo.lstRenovationTypes.length == 0) ||
      (supplementalInfo.lstRenovationExtentTypes.length == 0) ||
      supplementalInfo.lstLossTypes.length == 0
    )
      return true;
    else
      return false;
  }
  ngAfterViewChecked() {
   this.height=$('.container').height();
   this.height=this.height+150;
  }
  formatCurrency(lstLossHistory: any) {
    lstLossHistory.forEach((num1) => {
      var num = num1.amountPaid;
      num = num.toString().replace(/\$|\,/g, '');
      if(num==null || num=="")
      return;
      if (isNaN(num))
        num = "0";
      var sign = (num == (num = Math.abs(num)));
      num = (parseFloat(num).toFixed(2));
      var arrayAmount = num.split(".");
      var cents = arrayAmount[1];
      num = arrayAmount[0];
      for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++)
        num = num.substring(0, num.length - (4 * i + 3)) + ',' +
          num.substring(num.length - (4 * i + 3));
      var result = (((sign) ? '' : '-') + '$' + num + '.' + cents);
      num1.amountPaid=result;
    });
  }
  hideDatePicker(dp)
  {
    dp.hide();
  }

}
